import { Box, Button, Stack, Typography } from '@mui/material';
import { authContext } from '@staffedupusa/shared-components';
import { useContext, useState } from 'react';

import PickImageModal from '@components/PickImageModal/PickImageModal';
import { formatAddressString } from '@features/applications/components/ApplicantViewApplicantInfo/utils';
import { white } from '@styles/colors';
import { useUpdateEmployerProfileImage } from '@features/profile/hooks/useUpdateEmployerProfileImage';
import { useEnterpriseUpdateProfileImage } from '@features/profile/hooks/useEnterpriseUpdateProfileImage';
import LogoAndAddress from '@components/LogoAndAddress/LogoAndAddress';

const CompanyLogoAndCover = () => {
  const [isPickImageModalOpen, setIsPickImageModalOpen] = useState(false);
  const [errorText, setErrorText] = useState('');

  const {
    authData: { user },
  } = useContext(authContext);
  const { updateEnterpriseProfileImage, isUpdatingEnterpriseProfileImage } =
    useEnterpriseUpdateProfileImage({
      setAlertText: setErrorText,
    });
  const { updateEmployerProfileImage, isUpdatingEmployerProfileImage } =
    useUpdateEmployerProfileImage({
      setAlertText: setErrorText,
    });

  return (
    <Stack
      height="100%"
      width={{ xs: '100%', mg: 250 }}
      maxHeight="200px"
      bgcolor={white}
      borderRadius="8px"
      p={4}
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      spacing={3}
      sx={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundImage: user?.enterprise
          ? user?.enterprise?.s_cover_image_file
            ? `url(${user.enterprise.s_cover_image_file})`
            : 'none'
          : user?.company
            ? user?.company?.s_cover_image_file
              ? `url(${user.company.s_cover_image_file})`
              : 'none'
            : 'none',
      }}
    >
      <Box
        bgcolor={white}
        borderRadius="8px"
        width="100%"
        maxWidth={120}
        maxHeight={120}
        overflow="hidden"
        p={user?.enterprise?.s_logo_file || user?.company?.s_logo_file ? 1 : 3}
      >
        {user?.enterprise?.s_logo_file || user?.company?.s_logo_file ? (
          <LogoAndAddress
            logoUrl={
              user?.enterprise
                ? user?.enterprise?.s_logo_file ?? null
                : user?.company?.s_logo_file ?? null
            }
            maxWidth="100%"
            roundCorners
          />
        ) : (
          <Button
            variant="outlined"
            onClick={() => setIsPickImageModalOpen(true)}
          >
            Upload Logo
          </Button>
        )}
      </Box>
      {!user?.enterprise &&
        (user?.company?.s_address1 || user?.company?.s_address2) && (
          <Box
            bgcolor={white}
            padding={1}
            borderRadius="8px"
            width="100%"
            maxWidth={330}
          >
            <Typography style={{ fontSize: '13px' }}>
              {user?.company?.s_address1 || user?.company?.s_address2}
            </Typography>
            <Typography style={{ fontSize: '13px' }}>
              {formatAddressString({
                address1: null,
                city: user.company?.s_city,
                state: user?.company?.s_state,
                zip: user?.company?.s_zip,
              })}
            </Typography>
            <Typography style={{ fontSize: '13px' }}>
              {user?.country || 'US'}
            </Typography>
          </Box>
        )}
      <PickImageModal
        isOpen={isPickImageModalOpen}
        setIsOpen={setIsPickImageModalOpen}
        title="Upload Logo"
        imageType="logo"
        minWidth={320}
        minHeight={160}
        alertText={errorText}
        setAlertText={setErrorText}
        handleUpdateImage={
          user?.enterprise
            ? updateEnterpriseProfileImage
            : updateEmployerProfileImage
        }
        isUpdatingImage={
          user?.enterprise
            ? isUpdatingEnterpriseProfileImage
            : isUpdatingEmployerProfileImage
        }
      />
    </Stack>
  );
};

export default CompanyLogoAndCover;
